import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../data/Constants';
import { getPrice, deletePrice } from '../../store/states/PriceSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch, AppStore } from '../../store/AppStore';
import { setAlertMessage } from '../../store/states/AlertMessageSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const Prices = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.PriceKey);

  const deletePrices = () => {
    const price = AppStore.getState().dataMaintainance.prices;
    dispatch(deletePrice({ token: props.token })).then((res) => {
      if (res.payload?.data) {
        const message = t('messages.success.delete.prices');
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getPrice({
            token: props.token,
            page: price.currentPage,
            limit: price.recordsPerPage,
            searchCode: price.searchKey,
          })
        );
      } else {
        const message = t('messages.fail.delete.prices');
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.price')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.Prices}
        getDataList={getPrice}
        moduleType={EModuleType.Datamaintainance}
        deleteItems={deletePrices}
      />
    </>
  );
};
